var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{class:{ 'is-vertical': _vm.vertical },style:({ height: _vm.max ? '100%' : _vm.height })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }